package pwgs.ui.scenes.projectlist

import kotlinx.serialization.Serializable
import kotlinx.serialization.json.Json
import visage.core.*
import visage.rmi.*
import kotlin.coroutines.CoroutineContext
import kotlin.coroutines.suspendCoroutine
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.Job
import kotlinx.coroutines.launch

abstract class AProjectListControllerFe(props: pwgs.ui.scenes.projectlist.ProjectListSceneProps, scene: MProjectListScene)
 : AController<pwgs.ui.scenes.projectlist.ProjectListSceneProps, pwgs.ui.scenes.projectlist.ProjectListSceneModel, ProjectListSceneState>(props, scene) {

    val backend = ProjectListControllerBeProxy(this)
    val coroutineScope = DefaultControllerScope()

    fun launchOnDefaultControllerScope(block: suspend CoroutineScope.() -> Unit) {
        this.coroutineScope.launch(block = block)
    }

    fun call_load() {
        launchOnDefaultControllerScope {
            render(backend.load())
        }
    }

    fun call_createProject() {
        launchOnDefaultControllerScope {
            render(backend.createProject())
        }
    }

    class DefaultControllerScope : CoroutineScope {
        private val job = Job()

        override val coroutineContext: CoroutineContext
            get() = Dispatchers.Main + job
    }
}

class ProjectListControllerBeProxy(private val controller: AProjectListControllerFe) {

    suspend fun load(): pwgs.ui.scenes.projectlist.ProjectListSceneModel {
        @Serializable
        class ParamsWrapper()
        val params: String = Json.encodeToString(ParamsWrapper.serializer(), ParamsWrapper())
        val p = RmiParams(
            action = "pwgs.ui.scenes.projectlist.ProjectListControllerBe.load",
            methodParams = params,
            props = Json.encodeToString(pwgs.ui.scenes.projectlist.ProjectListSceneProps.serializer(), controller.props),
            currentModel = Json.encodeToString(pwgs.ui.scenes.projectlist.ProjectListSceneModel.serializer(), controller.model)
        )
        return suspendCoroutine { res ->
            val promise = RmiClient.call(p)
            RmiClient.handleResult(controller.model, res, promise, pwgs.ui.scenes.projectlist.ProjectListSceneModel.serializer())
        }
    }

    suspend fun createProject(): pwgs.ui.scenes.projectlist.ProjectListSceneModel {
        @Serializable
        class ParamsWrapper()
        val params: String = Json.encodeToString(ParamsWrapper.serializer(), ParamsWrapper())
        val p = RmiParams(
            action = "pwgs.ui.scenes.projectlist.ProjectListControllerBe.createProject",
            methodParams = params,
            props = Json.encodeToString(pwgs.ui.scenes.projectlist.ProjectListSceneProps.serializer(), controller.props),
            currentModel = Json.encodeToString(pwgs.ui.scenes.projectlist.ProjectListSceneModel.serializer(), controller.model)
        )
        return suspendCoroutine { res ->
            val promise = RmiClient.call(p)
            RmiClient.handleResult(controller.model, res, promise, pwgs.ui.scenes.projectlist.ProjectListSceneModel.serializer())
        }
    }

}
